function BannerModel() {

  const dataReturn = {
    bannerType: 0,
    bannerName: '',
    bannerImageScrollNew: {id: 0, timeStamp: '', nameFile: '', image: '', headImage: '', title: '', url: '', buttonCaption: ''},
    bannerImageScroll: [],
    imageX: '',
        url: '',
    timeStamp: '',
    headImage : '',
      image : '',
      buttonCaption : '',
    defaultBanner: false
  };

  return dataReturn;
}

export default BannerModel;
